
































































import axios from 'axios';
import { get } from 'lodash';
import CoAudioEmbed from '../../Molecules/co-audio-embed/CoAudioEmbed.vue';
import CoCard from '../../Molecules/co-card/CoCard.vue';
import CoVideoEmbed from '../../Molecules/co-video-embed/CoVideoEmbed.vue';
import CoIcon from '../../Atoms/co-icon/CoIcon.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import { getAudioProvider, getVideoProvider } from '../../../utils/video.ts';

export default {
    name: 'CoLinkPreview',
    components: { CoAudioEmbed, CoCard, CoText, CoIcon, CoSkeleton, CoVideoEmbed },
    props: {
        url: {
            type: String,
            default: '',
        },
        defaultClasses: {
            type: Object,
            default: null,
        },
        embedClasses: {
            type: Object,
            default: null,
        },
        videoClasses: {
            type: Object,
            default: null,
        },
        preventEmbedding: {
            type: Boolean,
            default: false,
        },
        // forced title for the link preview, if not provided it will be fetched using og tags or oembed data
        title: {
            type: String,
            default: null,
            required: false,
        },
    },
    data() {
        return {
            localtitle: null,
            loading: false,
            isInvalidURL: false,
            requestSequence: 0,
        };
    },
    computed: {
        isEmailLink() {
            return /mailto:/gi.test(this.url);
        },
        linkLabel() {
            return this.title || this.localtitle || this.url;
        },
        videoProvider() {
            return getVideoProvider(this.url);
        },
        audioProvider() {
            return getAudioProvider(this.url);
        },
        mediaProvider() {
            return this.videoProvider || this.audioProvider;
        },
    },
    mounted() {
        if (!this.url || this.url === '') return;
        this.processLinkPreview();
    },
    watch: {
        url() {
            this.processLinkPreview();
        },
    },
    methods: {
        processLinkPreview() {
            this.requestSequence += 1;
            const { requestSequence } = this;

            this.isInvalidURL = false;
            this.localtitle = null;
            this.loading = false;

            if (/mailto:/gi.test(this.url || '')) {
                this.localtitle = this.url.replace(/mailto:/gi, '');
                return;
            }

            try {
                const parsedUrl = new URL(this.url);
                if (!parsedUrl.hostname) {
                    throw new Error('URL has no hostname');
                }
            } catch (err) {
                this.isInvalidURL = true;
                return;
            }

            if (!this.mediaProvider || this.preventEmbedding) {
                this.getLinkInfo(requestSequence);
            }
        },
        getLinkInfo(requestSequence) {
            const url = new URL(this.url);
            this.loading = true;
            axios({
                method: 'GET',
                url: `/dashboard/og?url=${this.url}`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (requestSequence !== this.requestSequence) {
                        return;
                    }

                    this.localtitle = get(response, 'data.title');
                    if (this.localtitle && this.localtitle.length < 3) {
                        this.localtitle = url.hostname;
                    }
                })
                .catch(() => {
                    if (requestSequence !== this.requestSequence) {
                        return;
                    }

                    this.localtitle = url.hostname;
                })
                .finally(() => {
                    if (requestSequence === this.requestSequence) {
                        this.loading = false;
                    }
                });
        },
    },
};
